import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createStructure } from "src/Pages/Company/OrganizationStructure/api";
import { ICreateStructure } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/CreateStructure/CreateStructure.scheme";
import { useHistory } from "react-router-dom";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { useContext } from "react";
import RbsContext from "src/utils/RoleBasedSecurity/RbsContext";

const useCreateStructure = (companyId: string) => {
  const history = useHistory();
  const queryClient = useQueryClient();
  const { userInfo } = useContext(RbsContext);
  const isAhr = userInfo.isAhr();

  return useMutation({
    mutationFn: async (formData: ICreateStructure) =>
      createStructure(companyId, formData),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie zapisano dane"), "success");
      history.push(
        isAhr
          ? `/ahr/organization-structure/configure-structure/structure-areas`
          : `/company/edit/${companyId}/organization-structure/configure-structure/structure-areas`
      );
      queryClient.invalidateQueries({
        queryKey: ["list-of-structures", { companyId }],
      });
    },
    onError: () => {
      dynamicNotification(__("Nie udało się zapisać danych"), "error");
    },
  });
};

export default useCreateStructure;
